import type { State as S, Selector } from 'model/State';

export const selectGenericProperty: Selector<unknown> = (state: S) =>
  state.mac.genericProperty.genericProperty;

export const selectGenericPropertyByFullKey = (state: S, fullKey: string) =>
  state.mac.genericProperty.genericProperty?.[fullKey]?.ifSuccess((r) => r);
